"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK = void 0;
const ky_1 = __importDefault(require("ky"));
const mitt_1 = __importDefault(require("mitt"));
function isEmpty(obj) {
    for (const prop in obj) {
        if (obj.hasOwnProperty(prop))
            return false;
    }
    return true;
}
class SDK {
    constructor(config) {
        var _a;
        this.on = (type, handler) => {
            return this.emitter.on(type, handler);
        };
        this.off = (type, handler) => {
            return this.emitter.off(type, handler);
        };
        this.emit = (type, event) => {
            return this.emitter.emit(type, event);
        };
        /**
         * Search for tours
         */
        this.searchTours = (params, body) => {
            const path = `collections/tours/documents/search`;
            const searchParams = Object.assign({}, "q" in params && params["q"] ? { q: params["q"].toString() } : null, "when" in params && params["when"]
                ? { when: params["when"].toString() }
                : null);
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("searchToursResponse");
                        }
                        else {
                            this.emitter.emit("searchToursError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        /**
         * Geocode location string
         */
        this.geocode = (params, body) => {
            const path = `geocode`;
            const searchParams = Object.assign({}, "q" in params && params["q"] ? { q: params["q"].toString() } : null, "language" in params && params["language"]
                ? { language: params["language"].toString() }
                : null);
            const hooks = {
                afterResponse: [
                    (_input, _options, response) => {
                        if (response.ok) {
                            this.emitter.emit("searchToursResponse");
                        }
                        else {
                            this.emitter.emit("searchToursError");
                        }
                    },
                ],
            };
            return this.http
                .get(path, Object.assign({ searchParams, hooks }, body ? { json: body } : null))
                .json();
        };
        this.http = ky_1.default.extend({
            prefixUrl: config.baseURL,
            timeout: (_a = config.requestTimeout) !== null && _a !== void 0 ? _a : false,
            headers: config.headers,
        });
        this.emitter = (0, mitt_1.default)();
        this.config = config;
    }
    get all() {
        return this.emitter.all;
    }
}
exports.SDK = SDK;
